<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Folders" class="d-icon d-icon--folders" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.94 1.94A1.5 1.5 0 0 1 4 1.5h1.968a1.5 1.5 0 0 1 1.242.671l.413.604A.5.5 0 0 0 8.037 3H10a1.5 1.5 0 0 1 1.5 1.5v3A1.5 1.5 0 0 1 10 9H4c-.826 0-1.5-.674-1.5-1.5V3c0-.398.158-.78.44-1.06ZM4 2.5a.5.5 0 0 0-.5.5v4.5c0 .274.226.5.5.5h6a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 10 4H8.032a1.5 1.5 0 0 1-1.242-.671l-.413-.604a.5.5 0 0 0-.414-.225H4Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1 3.5a.5.5 0 0 1 .5.5v5.5c0 .274.226.5.5.5h7a.5.5 0 0 1 0 1H2c-.826 0-1.5-.674-1.5-1.5V4a.5.5 0 0 1 .5-.5Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconFolders',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
